export const FOOTER_LINKS = {
    legals: {
        title: 'Legals',
        links: [
            { text: 'General terms of service', url: route('web.pages.general-terms') },
            { text: 'Privacy policy', url: route('web.pages.privacy') },
            { text: 'Website terms of use', url: route('web.pages.website-terms') },
            { text: 'California privacy notice', url: route('web.pages.california-privacy') },
            { text: 'Data processing addendum', url: route('web.pages.data-processing') },
        ],
    },
    product: {
        title: 'Product',
        links: [
            { text: 'Our Software', url: route('web.pages.features') },
            { text: 'Integrations', url: route('web.integrations.index') },
            { text: 'Rewards', url: route('web.pages.rewards') },
            { text: 'Templates', url: route('web.templates.index') },
            {
                text: 'API Docs',
                newTab: true,
                url: 'https://developers.referral-factory.com/',
                external: true,
            },
            {
                text: 'Help Guide',
                newTab: true,
                url: 'https://help.referral-factory.com/en/',
                external: true,
            },
            { text: 'Contact', url: route('web.pages.contact') },
        ],
    },
    tools: {
        title: 'Tools and resources',
        links: [
            { text: 'Calculate your referral rate', url: route('web.pages.calculator') },
            {
                text: 'Free referral link generator',
                url: route('web.pages.create-a-referral-program'),
            },
            { text: 'Referral program examples', url: route('web.pages.campaign_examples') },
            { text: 'Success stories & benchmarks', url: route('web.pages.success_stories') },
            {
                text: 'Referral marketing statistics',
                url: route('web.pages.marketing_statistics'),
            },
            {
                text: 'What is referral marketing software?',
                url: route('web.pages.marketing_software'),
            },
            { text: 'Referral tracking', url: route('web.pages.features') },
        ],
    },
    quick_links: {
        title: 'Quick links',
        links: [
            {
                text: 'Create a referral link',
                newTab: true,
                url: 'https://referral-factory.com/learn/how-to-create-a-referral-link-a-step-by-step-guide',
                external: true,
            },
            {
                text: 'Stripe referral program',
                newTab: true,
                url: 'https://referral-factory.com/learn/stripe-referral-program',
                external: true,
            },
            {
                text: 'HubSpot referral program ',
                newTab: true,
                url: 'https://referral-factory.com/learn/hubspot-referral-program',
                external: true,
            },
        ],
    },
    affiliates: {
        title: 'For affiliates',
        links: [
            { text: __('Best programs to earn'), url: route('web.campaigns.index') },
            {
                text: __('Join our affiliate program '),
                newTab: true,
                url: import.meta.env.VITE_MAIN_CAMPAIGN_URL,
                external: true,
            },
            {
                text: __('Become an affiliate'),
                newTab: true,
                url: 'https://referral-factory.com/learn/what-is-an-affiliate',
                external: true,
            },
        ],
    },
    find_us: {
        title: 'Find us',
        links: [
            {
                external: true,
                newTab: true,
                text: 'Amsterdam, Netherlands.',
                url: 'https://maps.app.goo.gl/SjXvDM2hmqoK4mZR8',
            },
            {
                text: __('Log into your account'),
                url: route('customer.auth.login'),
            },
        ],
    },
};

export const SOCIALS = [
    {
        img: '/assets/images/svg/web/socials/youtube.svg',
        url: 'https://www.youtube.com/@ReferralFactory',
        alt: 'YouTube',
        newTab: true,
        external: true,
    },
    {
        img: '/assets/images/svg/web/socials/linkedin.svg',
        url: 'https://www.linkedin.com/company/referral-factory',
        alt: 'Linkedin',
        newTab: true,
        external: true,
    },
    {
        img: '/assets/images/svg/web/socials/x.svg',
        url: 'https://x.com/referralfctry',
        alt: 'X',
        newTab: true,
        external: true,
    },
    { img: '/assets/images/svg/web/socials/facebook.svg', url: '', alt: 'Facebook' },
];
